import { render } from "./ClientGuiaRemision.vue?vue&type=template&id=67f344ef&scoped=true"
import script from "./ClientGuiaRemision.vue?vue&type=script&lang=js"
export * from "./ClientGuiaRemision.vue?vue&type=script&lang=js"

import "./ClientGuiaRemision.vue?vue&type=style&index=0&id=67f344ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f344ef"]])

export default __exports__